export interface EntityDatasource {
    entityName?: string;
    entityTitle?: string;
    parentProp?: string;
    idProp?: string;
    nameProp?: string;
}